import InvestmentsInput from "./InvestmentsInput"

export default InvestmentsInput
